<template>
  <div class="activity">
    <img src="@/assets/images/website/activity.png" alt @click="onClick" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      activities: []
    };
  },

  mounted() {
    this.queryActivity();
  },
  methods: {
    queryActivity() {
      this.$api
        .queryOngoingActivities()
        .then(result => {
          if (result.data.success) {
            this.activities = result.data.data;
          } else {
            this.activities = [];
          }
        })
        .catch(err => {});
    },
    onClick() {
      let routeUrl = this.$router.resolve({
        path: "/activity"
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.activity {
  // height: 60px;
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/components/banner.vue